<template>
	<MkLoading />
</template>

<script lang="ts" setup></script>
